export default __webpack_public_path__ + "static/media/avatarwoman3.6767b41d.png";